import axios from 'axios';
import { browserHistory } from 'react-router';
import { SubmissionError } from 'redux-form';
import { toFromDates } from '../components/Common/cleanDates';

import {
  REQUEST_INVENTORIES,
  FETCH_INVENTORIES_SUCCESS,
  FETCH_INVENTORIES_FAILURE,
  REQUEST_SALES_ORDER_INVENTORY,
  FETCH_SALES_ORDER_INVENTORY_SUCCESS,
  FETCH_SALES_ORDER_INVENTORY_FAILURE,
  REQUEST_DETAILED_INVENTORIES,
  FETCH_DETAILED_INVENTORIES_SUCCESS,
  FETCH_DETAILED_INVENTORIES_FAILURE,
  SELECT_INVENTORY,
  RESET_CURRENT_INVENTORY,
  REQUEST_INVENTORY_DETAIL,
  FETCH_INVENTORY_DETAIL_SUCCESS,
  FETCH_INVENTORY_DETAIL_FAILURE,
  REQUEST_LOW_STOCK_INVENTORIES,
  FETCH_LOW_STOCK_INVENTORIES_SUCCESS,
  FETCH_LOW_STOCK_INVENTORIES_FAILURE,
  REQUEST_EXPIRED_INVENTORIES,
  FETCH_EXPIRED_INVENTORIES_SUCCESS,
  FETCH_EXPIRED_INVENTORIES_FAILURE,
  REQUEST_INVENTORIES_BY_GROUP,
  REQUEST_INVENTORIES_BY_GROUP_SUCCESS,
  REQUEST_INVENTORIES_BY_GROUP_FAILURE,
  REQUEST_INVENTORIES_BY_CATEGORY,
  REQUEST_INVENTORIES_BY_CATEGORY_SUCCESS,
  REQUEST_INVENTORIES_BY_CATEGORY_FAILURE,
  REQUEST_INVENTORIES_BY_PERIOD,
  FETCH_INVENTORIES_BY_PERIOD_SUCCESS,
  FETCH_INVENTORIES_BY_PERIOD_FAILURE,
  SET_ORIGIN_PAGE,
  REQUEST_NONZERO_INVENTORIES,
  FETCH_NONZERO_INVENTORIES_SUCCESS,
  FETCH_NONZERO_INVENTORIES_FAILURE,
  REQUEST_LOW_INVENTORIES,
  FETCH_LOW_INVENTORIES_SUCCESS,
  FETCH_LOW_INVENTORIES_FAILURE,
  REQUEST_WORKING_ORDERS,
  FETCH_WORKING_ORDERS_SUCCESS,
  FETCH_WORKING_ORDERS_FAILURE,
  REQUEST_SIMPLIFIED_PRODUCTS,
  FETCH_SIMPLIFIED_PRODUCTS_SUCCESS,
  FETCH_SIMPLIFIED_PRODUCTS_FAILURE,
  FETCH_VENDOR_BATCHES,
  FETCH_VENDOR_BATCHES_SUCCESS,
  FETCH_VENDOR_BATCHES_FAILURE,
  FETCH_INVENTORY_HISTORY,
  FETCH_INVENTORY_HISTORY_SUCCESS,
  FETCH_INVENTORY_HISTORY_FAILURE,
  FETCH_INVENTORY_ADJUSTMENT_BATCH_LOG,
  UPDATE_INVENTORY_FILTER,
  FETCH_INVENTORIES_DETAILS_SUCCESS,
  RESET_FILTER_WITH_NEW_ID,
  UPDATE_RECEIVE_TABLE_FILTER,
  FETCH_INVENTORIES_PRODUCT_RECEIVE_SUCCESS,
  RESET_RECEIVE_FILTER_WITH_NEW_ID,
} from './type';

import {
  INVENTORIES_URL,
  INVENTORY_URL,
  INVENTORY_HISTORY_URL,
  DETAILED_INVENTORIES_URL,
  SALES_ORDER_INVENTORY_URL,
  WAREHOUSES_URL,
  WHOLESALE_BATCH_LOG_URL,
  PRODUCT_RECEIVE_HISTORY,
  INVENTORY_SALES_ORDER_HISTORY_URL,
} from './url';

import { DEFAULT_ERROR } from '../components/Common/constants';
import { isGGI, isVAK, isSH, isAP, isGFD } from './root_url';

// Inventories Actions
const generateNewReceiveFilter = () => {
  var date = new Date();
  var last = new Date(date.getTime() - (7 * 24 * 60 * 60 * 1000));
  return {
    start_date: last,
    end_date: date,
  }
}

export const fetchReceiveHistoryFilterInitial = () => {
  return dispatch => {
    dispatch({ type: RESET_RECEIVE_FILTER_WITH_NEW_ID, payload: generateNewReceiveFilter()})
  }
}

const generateNewFilter = (id) => {
  var date = new Date();
  var last = new Date(date.getTime() - (7 * 24 * 60 * 60 * 1000));
  return {
    start_date: last,
    end_date: date,
  }
}

export function handleInventoryClick(id) {
  return dispatch => {
    dispatch({ type: RESET_FILTER_WITH_NEW_ID, payload: generateNewFilter(id)})
  }
}

export function updateFilter(data) {
  return dispatch => {
    dispatch({
      type: UPDATE_INVENTORY_FILTER,
      payload: data
    })
  }
}

export function updateReceiveTableFilter(data) {
  return dispatch => {
    dispatch({
      type: UPDATE_RECEIVE_TABLE_FILTER,
      payload: data
    })
  }
}

export function fetchReceiveHistory(id, warehouseId) {
  return (dispatch, getState) => {
    const receiveTableFilter = getState().inventoryAdjustments.receiveTableFilter;
    const date = toFromDates(null, receiveTableFilter.start_date, receiveTableFilter.end_date);
    let params = {
      start_date: date.fromDate,
      end_date: date.toDate,
    }
    if (isVAK || isSH || isAP || isGFD) {
      params.warehouse_id = warehouseId
    }
    axios.get(`${PRODUCT_RECEIVE_HISTORY}${id}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params
    })
    .then(res => {
      dispatch({
        type: FETCH_INVENTORIES_PRODUCT_RECEIVE_SUCCESS,
        payload: res.data
      })
    })
    .catch(err => {
      console.log('error fethcing receiving history of a product',err)
    })
  }
}

export function fetchInventoriesDetails(id, company, warehouseId) {
  return (dispatch, getState) => {
    const filters = getState().inventoryAdjustments.filters;
    const date = toFromDates(null, filters.start_date, filters.end_date);
    let params = {
      end_date: date.toDate,
      start_date: date.fromDate,
    }
    if (isVAK || isSH || isAP || isGFD) {
      params.company = company
      params.warehouse_id = warehouseId
    }
    axios.get(`${INVENTORY_SALES_ORDER_HISTORY_URL}${id}`, {
      params,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
    .then(res => {
      dispatch(fetchInventoriesDetailsSuccess(res.data));
      dispatch({ type: FETCH_INVENTORIES_DETAILS_SUCCESS})

    })
    .catch(err => {
      console.log('err fetching inventories details', err);
    })
  }
}

function fetchInventoriesDetailsSuccess(data) {
  return {
    type: FETCH_INVENTORY_ADJUSTMENT_BATCH_LOG,
    payload: data,
  }
}
export function fetchInventories() {
  return (dispatch) => {
    dispatch({ type: REQUEST_INVENTORIES });
    return axios.get(
      INVENTORIES_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchInventoriesSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchInventoriesFailure(err));
        }
      });
  };
}

export function fetchInventoriesSuccess(inventories) {
  return {
    type: FETCH_INVENTORIES_SUCCESS,
    payload: inventories,
  };
}

export function fetchInventoriesFailure(error) {
  return {
    type: FETCH_INVENTORIES_FAILURE,
    payload: error,
  };
}

export function fetchInventoriesByGroup(id) {
  if (id == -1) {
    return (dispatch) => { dispatch(fetchDetailedInventories()); };
  }
  return (dispatch) => {
    dispatch({ type: REQUEST_INVENTORIES_BY_GROUP });
    return axios.get(
      `${INVENTORY_URL}group/${id}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchInventoriesByGroupSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchInventoriesByGroupFailure(err));
        }
      });
  };
}

export function fetchInventoriesByGroupSuccess(response) {
  return {
    type: REQUEST_INVENTORIES_BY_GROUP_SUCCESS,
    payload: response,
  };
}

export function fetchInventoriesByGroupFailure(error) {
  return {
    type: REQUEST_INVENTORIES_BY_GROUP_FAILURE,
    payload: error,
  };
}

export function fetchInventoriesByCategory(id) {
  if (id == -1) {
    return (dispatch) => { dispatch(fetchDetailedInventories()); };
  }
  return (dispatch) => {
    dispatch({ type: REQUEST_INVENTORIES_BY_CATEGORY });
    return axios.get(
      `${INVENTORY_URL}category/${id}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchInventoriesByCategorySuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchInventoriesByCategoryFailure(err));
        }
      });
  };
}

export function fetchInventoriesByCategorySuccess(response) {
  return {
    type: REQUEST_INVENTORIES_BY_CATEGORY_SUCCESS,
    payload: response,
  };
}

export function fetchInventoriesByCategoryFailure(error) {
  return {
    type: REQUEST_INVENTORIES_BY_CATEGORY_FAILURE,
    payload: error,
  };
}

export function fetchDetailedInventories() {
  return (dispatch) => {
    dispatch({ type: REQUEST_DETAILED_INVENTORIES });
    return axios.get(
      DETAILED_INVENTORIES_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchDetailedInventoriesSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchDetailedInventoriesFailure(err));
        }
      });
  };
}

export function fetchDetailedInventoriesSuccess(inventory) {
  return {
    type: FETCH_DETAILED_INVENTORIES_SUCCESS,
    payload: inventory,
  };
}

export function fetchDetailedInventoriesFailure(error) {
  return {
    type: FETCH_DETAILED_INVENTORIES_FAILURE,
    payload: error,
  };
}

export function fetchLowStockInventoryInventories() {
  return (dispatch) => {
    dispatch({ type: REQUEST_LOW_STOCK_INVENTORIES });
    return axios.get(
      `${INVENTORY_URL}lowstock/`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchLowStockInventoryInventoriesSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchLowStockInventoryInventoriesFailure(err));
        }
      });
  };
}

export function fetchLowStockInventoryInventoriesSuccess(lowStockInventories) {
  return {
    type: FETCH_LOW_STOCK_INVENTORIES_SUCCESS,
    payload: lowStockInventories,
  };
}

export function fetchLowStockInventoryInventoriesFailure(error) {
  return {
    type: FETCH_LOW_STOCK_INVENTORIES_FAILURE,
    payload: error,
  };
}

export function fetchExpiredInventories() {
  return (dispatch) => {
    dispatch({ type: REQUEST_EXPIRED_INVENTORIES });
    return axios.get(
      `${INVENTORY_URL}batch/`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchExpiredInventoriesSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchExpiredInventoriesFailure(err));
        }
      });
  };
}

export function fetchExpiredInventoriesSuccess(expiredInventories) {
  return {
    type: FETCH_EXPIRED_INVENTORIES_SUCCESS,
    payload: expiredInventories,
  };
}

export function fetchExpiredInventoriesFailure(error) {
  return {
    type: FETCH_EXPIRED_INVENTORIES_FAILURE,
    payload: error,
  };
}

export function selectInventory(inventory) {
  return {
    type: SELECT_INVENTORY,
    payload: inventory,
  };
}

export function resetCurrentInventory() {
  return {
    type: RESET_CURRENT_INVENTORY,
  };
}


export function fetchInventoryDetail(inventory_id, companyId, warehouseId) {
  return (dispatch) => {
    dispatch({ type: REQUEST_INVENTORY_DETAIL });
    return axios.get(
      INVENTORY_URL + inventory_id + `?company=${companyId}&warehouse=${warehouseId}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchInventoryDetailSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchInventoryDetailFailure(err));
        }
      });
  };
}

export function fetchInventoryDetailSuccess(inventoryDetail) {
  return {
    type: FETCH_INVENTORY_DETAIL_SUCCESS,
    payload: inventoryDetail,
  };
}

export function fetchInventoryDetailFailure(error) {
  return {
    type: FETCH_INVENTORY_DETAIL_FAILURE,
    payload: error,
  };
}

export function fetchSalesOrderInventory() {
  return (dispatch) => {
    dispatch({ type: REQUEST_SALES_ORDER_INVENTORY });
    return axios.get(
      SALES_ORDER_INVENTORY_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrderInventorySuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchSalesOrderInventoryFailure(err));
        }
      });
  };
}

export function fetchSalesOrderInventorySuccess(inventory) {
  return {
    type: FETCH_SALES_ORDER_INVENTORY_SUCCESS,
    payload: inventory,
  };
}

export function fetchSalesOrderInventoryFailure(error) {
  return {
    type: FETCH_SALES_ORDER_INVENTORY_FAILURE,
    payload: error,
  };
}

export function fetchAllInventories(type) {
  return (dispatch) => {
    dispatch({ type: REQUEST_INVENTORIES_BY_PERIOD });
    return axios.get(
      DETAILED_INVENTORIES_URL + type,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchInventoriesByPeriodSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchInventoriesByPeriodFailure(err));
        }
      });
  };
}

export function fetchInventoriesByPeriod(type, division, startDate, endDate, warehouse) {
  const dates = toFromDates(-1, startDate, endDate);
  return (dispatch) => {
    dispatch({ type: REQUEST_INVENTORIES_BY_PERIOD });
    if (type !== 'Inactive' && type !== 'Active') {
      let url;
      if (division === '') {
        url = `${DETAILED_INVENTORIES_URL}${type}/${(warehouse !== '') ? `?${warehouse}` : ''}`;
      } else {
        url = `${DETAILED_INVENTORIES_URL}${type}/?${division}${(warehouse !== '') ? `&${warehouse}` : ''}`;
      }
      return axios.get(
        url,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        },
      )
        .then((response) => {
          dispatch(fetchInventoriesByPeriodSuccess(response));
        }, (err) => {
          if (err.status === 500 || err.status === 404) {
            err.data = DEFAULT_ERROR;
          }
          if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
            document.getElementById('tokenInvalid').style.display = 'flex'
          } else {
            dispatch(fetchInventoriesByPeriodFailure(err));
          }
        });
    }
    const warehouseQuery = (warehouse !== '') ? `&${warehouse}` : '';
    let url;
    if (division === '') {
      url = `${DETAILED_INVENTORIES_URL}${type}/?startdate=${dates.fromDate}&enddate=${dates.toDate}${warehouseQuery}`;
    } else {
      url = `${DETAILED_INVENTORIES_URL}${type}/?${division}&startdate=${dates.fromDate}&enddate=${dates.toDate}${warehouseQuery}`;
    }
    return axios.get(
      url,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchInventoriesByPeriodSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchInventoriesByPeriodFailure(err));
        }
      });
  };
}

export function fetchInventoriesByPeriodSuccess(inventory) {
  return {
    type: FETCH_INVENTORIES_BY_PERIOD_SUCCESS,
    payload: inventory,
  };
}

export function fetchInventoriesByPeriodFailure(error) {
  return {
    type: FETCH_INVENTORIES_BY_PERIOD_FAILURE,
    payload: error,
  };
}

export function setOriginPage(page) {
  return {
    type: SET_ORIGIN_PAGE,
    payload: page,
  };
}

export function fetchNonZeroInventories() {
  return (dispatch) => {
    dispatch({ type: REQUEST_INVENTORIES_BY_PERIOD });
    return axios.get(
      `${DETAILED_INVENTORIES_URL}NonZero`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchNonZeroInventoriesSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchNonZeroInventoriesFailure(err));
        }
      });
  };
}

export function fetchNonZeroInventoriesSuccess(items) {
  return {
    type: FETCH_NONZERO_INVENTORIES_SUCCESS,
    payload: items,
  };
}

export function fetchNonZeroInventoriesFailure(error) {
  return {
    type: FETCH_NONZERO_INVENTORIES_FAILURE,
    payload: error,
  };
}

export function fetchLowInventories(PackageSize, Stock) {
  return (dispatch) => {
    dispatch({ type: REQUEST_LOW_INVENTORIES });
    let url = `${WAREHOUSES_URL}lowinventory/`;
    if (PackageSize && Stock) { url = `${url}?PackageSize=${PackageSize}&Stock=${Stock}`; } else if (PackageSize) { url = `${url}?PackageSize=${PackageSize}`; } else if (Stock) { url = `${url}?Stock=${Stock}`; }
    return axios.get(
      url,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchLowInventoriesSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchLowInventoriesFailure(err));
        }
      });
  };
}

export function fetchLowInventoriesSuccess(items) {
  return {
    type: FETCH_LOW_INVENTORIES_SUCCESS,
    payload: items,
  };
}

export function fetchLowInventoriesFailure(error) {
  return {
    type: FETCH_LOW_INVENTORIES_FAILURE,
    payload: error,
  };
}

export function fetchWorkingOrders(date) {
  return (dispatch) => {
    dispatch({ type: REQUEST_WORKING_ORDERS });
    return axios.get(
      `${WAREHOUSES_URL}lowinventory/?Date=${date}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchWorkingOrdersSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchWorkingOrdersFailure(err));
        }
      });
  };
}

export function fetchWorkingOrdersSuccess(data) {
  return {
    type: FETCH_WORKING_ORDERS_SUCCESS,
    payload: data,
  };
}

export function fetchWorkingOrdersFailure(error) {
  return {
    type: FETCH_WORKING_ORDERS_FAILURE,
    payload: error,
  };
}

export function voidWorkingOrder(warehouseConvertId, handleSuccess, handleFailure) {
  return axios({
    method: 'delete',
    url: `${WAREHOUSES_URL}convert/${warehouseConvertId}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
    .then((response) => {
      handleSuccess(response);
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        handleFailure(err);
      }
    });
}

export function fetchReturnBatch(searchType, searchValue) {
  let RESEARCH_URL = '';
  if (searchType && searchValue) {
    RESEARCH_URL = `?${searchType}=${searchValue}`;
  }
  return (dispatch, getState) => {
    const state = getState();
    const warehouse = state.header.selectedWarehouse;
    const URL = `${INVENTORY_URL}returnbatch/${RESEARCH_URL}&warehouse_id=${warehouse.value}`;
    dispatch({ type: FETCH_VENDOR_BATCHES });
    axios.get(
      URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchReturnBatchSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchReturnBatchFailure(err));
        }
      });
  };
}

export function fetchReturnBatchSuccess(products) {
  return {
    type: FETCH_VENDOR_BATCHES_SUCCESS,
    payload: products,
  };
}

export function fetchReturnBatchFailure(error) {
  return {
    type: FETCH_VENDOR_BATCHES_FAILURE,
    payload: error,
  };
}


export function fetchInventoryHistorySuccess(products) {
  return {
    type: FETCH_INVENTORY_HISTORY_SUCCESS,
    payload: products,
  };
}

export function fetchInventoryHistoryFailure(error) {
  return {
    type: FETCH_INVENTORY_HISTORY_FAILURE,
    payload: error,
  };
}

export function fetchInventoryHistory(productId, fromDate, toDate, warehouseId = null) {
  const dates = toFromDates(-1, fromDate, toDate);
  return (dispatch) => {
    dispatch({ type: FETCH_INVENTORY_HISTORY });
    axios.get(
      `${INVENTORY_HISTORY_URL}${productId}?start_date=${dates.fromDate}&end_date=${dates.toDate}${warehouseId ? `&warehouse_id=${warehouseId}` : ''}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchInventoryHistorySuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchInventoryHistoryFailure(err));
        }
      });
  };
}



// WEBPACK FOOTER //
// ./master/jsx/actions/inventories_actions.jsx